// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperMain_root__175HC"};